import { combineReducers } from 'redux';

const defaultLogUploadParams = {
    datafetched :'waiting'
}

function params(state = defaultLogUploadParams, action) {
    if (action.type === 'FETCH_LOG_UPLOAD') {
        return {...state,
            datafetched: 'pending',
        }
    }
    if (action.type === 'FETCHED_LOG_UPLOAD') {
        return {...state,
            datafetched: 'success',
        }
    }
    if (action.type === 'RESET_DATA') {
        return defaultLogUploadParams
      } else {
        return state
    }
}

const logUpload = combineReducers({
    params
});

export default logUpload;